module.exports = {
    financialUser:{
        Uid :'账户ID',
        Phone : '电话',
        Email : '邮箱',
        Institution_number:'社会信用编码',
        Account_name:'账户名称',
        Company_name:'公司名称',
        ComCity:'地区',
        AccountStatus:'用户状态'
    },
    FinancialTicket:{
        CompanyName :'公司名称',
        Institution_number : '社会信用编码',
        BankName : '银行名称',
        Bank_Account:'银行账户',
        Recipients:'收件人',
        Addressed:'收件人地址',
        Phone:'收件人电话',
        Postalcode:'邮编',
        Account_name:'账户名称',
        Ticketaddress:'开票地址',
        TicketPhone:'开票电话'
    },
    sysUser:{
        Region:'地区',
        PositionName:'职务',
        DutyType:'岗位类别',
        Duty:'岗位',
        UserName:'用户名',
        Phone:'电话号码',
        LastLoginTime:'最后登录时间',
        LastLoginIp:'最后登录IP',
        HeadImg:'证件照',
        FileStatus:'文件状态',
        Status:'入职状态',
    },//用户基本信息
    userBase:{
        SalaryType:'薪酬体系',
        RankName:'薪级',
        LevelName:'薪档',
        HiredDate:'入职时间',
        SalaryDate:'计薪时间',
        IsRegular:'是否转正',
        RegularDate:'转正时间',
        Politcal:'政治面貌',
        WorkPlace:'工作地点',
        InsuranceStatus:'保险办理情况',
        RecruitIncome:'招聘来源',
        Nature:'民族',
        IDNum:'身份证号',
        IDCardAttachPositive:'身份证国徽面照片',
        IDCardAttachOppsite:'身份证信息面照片',
        IsPossess:'是否有中心银行卡号',
        CardNo:'中信银行卡卡号', 
        ExpirationTime:'身份证截止日期',
        PSB:'身份证签发机关',
    },//用户基本信息
    userContact:{
        CompanyPhone:'公司手机号',
        PersonalPhone:'个人手机号',
        NativePlace:'籍贯',
        ResidenceType:'户籍类型',
        Address:'户籍地址',
        NowAddress:'现住址',
    },//用户联系信息
    userContract:{
        ContractBegin:'合同开始时间',
        ContractEnd:'合同结束时间',
        ContractType:'用工类型',
    },//用户合同信息
    userEducation:{
        HighestEducation:'最高学历',
        GraduateDate:'毕业时间',
        GraduateSchool:'毕业院校',
        EducationAttach:'学历证书',
        DegreeAttach:'学位证书',
        Subject:'所学专业',
    },//用户教育信息
    userEmergency:{
        LinkName:'联系人姓名',
        LinkType:'联系人关系',
        LinkPhone:'联系人电话',
    },//紧急联系人信息
    userFamily:{
        MarriageStatus:'婚姻状况',
        MarriageDay:'结婚纪念日',
        IsHaveChild:'是否生育',
    },//家庭信息
    userQualification:{
        QualificationName:'资质名称',
        QualificationDate:'获得该资质时间',
        QualificationAttach:'资质证书',
    },//资质信息
    userWorkHistory:{
        CompanyName: '公司名称',//公司名称
        Position:'所任职务',//所任职务
        LeaveReason:'离职原因',//离职原因
        CompanyType:'公司性质',//公司性质
        BeginDate:'开始时间',//开始时间
        EndDate:'结束时间',//结束时间
        WorkmatePhone:'同事电话',//同事电话
        Size:'公司规模',//公司规模
    },//工作经历
    frameInfo:{//部门信息
        DingId:'钉钉部门id',
        DingDepartMentName:'钉钉部门名称',
        TecentMailId:'邮箱部门id',
        TecentMailDepartMentName:'邮箱部门名称',
        EnterpriseWeChatDepartmentId:'企业微信部门id',
        EnterpriseWeChatDepartmentName:'企业微信名称',
        ClassName:'部门名称',
        ParentId:'父级部门id',
        ParentName:'父级名称',
        Level:'部门级别',
        LevelName:'部门级别名称',
        Sflag:'企业标识',
        UserCode:'负责人工号',
        TrueName:'负责人名称',
        FrameType:'部门类型',
        Level:'部门级别',
    },
    userInfoModel:{
        ComputerConfiguration:'电脑配置',
        ComputerModels:'电脑编号',
        ContractType:'合同类型',
        ContractBegin:'合同开始时间',
        ContractEnd:'合同结束时间',
        SourceFor:'渠道来源',
        Referees:'推荐人',
        RecommendBonus:'入职推荐奖金',
        PositiveRecommendBonus:'转正推荐奖金',
        Remarks:'入职备注',
        TrueName:'姓名',
        MainDeptsName:'部门名称',
        MainDeptsID:'部门编号',
        PositionId:'员工职务编号',
        PositionName:'员工职务名称',
        DutyTypeId:'岗位类别id',
        DutyType:'岗位类别',
        DutyId:'岗位id',
        Duty:'岗位',
        UserCode:'员工编号',
        UserName:'邮箱',
        SalaryType:'薪资类别',
        SalaryID:'薪资类别编号',
        RankName:'职级名称',
        RankID:'职级编号',
        LevelName:'薪档名称',
        LevelID:'薪档编号',
        RegularRankId:'转正后职级id',
        RegularRankName:'转正后职级名称',
        RegularLevelId:'转正后薪档编号',
        RegularLevelName:'转正后薪档名称',
        HiredDate:'入职时间',
        SalaryDate:'计薪时间',
        IsRegular:'是否转正',
        RegularDate:'转正时间',
        Phone:'电话号码',
        InsuranceStatus:'保险办理情况',
        RecruitIncome:'招聘来源',
        IsAddTecentMail:'是否添加邮箱',
        IsAddDing:'是否添加钉钉',
        IsAddEnterpriseWeChat:'是否添加企业微信',
        NursingPerformance:'保育绩效',
    },//发起入职用户信息
    userInfo:{
        Id:'用户Id',
        UserCode:'工号',
        TrueName:'真实姓名',
        DutyType:'岗位类别',
        Duty:'岗位',
        UserName:'用户名',
        Phone:'电话号码',
        FullPath:'全部部门',
    },//用户基本信息
}